import {gql, useApolloClient} from '@apollo/client';
import {useEffect, useState} from 'react';

import {useIsMounted} from './useIsMounted';

const VIEWER_QUERY = gql`
  query Viewer2 {
    viewer {
      id
      username
    }
  }
`;

type UserInfo2 = {
  id: string;
  username: string;
};
type UserInfoResponseLoading = {
  loading: true;
  userInfo: {};
};
type UserInfoResponseSuccess = {
  loading: false;
  userInfo: UserInfo2;
};
type UserInfoResponse2 = UserInfoResponseLoading | UserInfoResponseSuccess;

// GraphQL version
export const useViewerUserInfo2 = (): UserInfoResponse2 => {
  const [userInfo, setUserInfo] = useState<UserInfo2 | null>(null);
  const apolloClient = useApolloClient();
  const isMounted = useIsMounted();
  useEffect(
    () => {
      apolloClient.query({query: VIEWER_QUERY as any}).then(result => {
        const info = result.data.viewer;
        if (isMounted()) {
          setUserInfo(info);
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (userInfo === null) {
    return {loading: true, userInfo: {}};
  }
  return {
    loading: false,
    userInfo,
  };
};
